import { render, staticRenderFns } from "./illlegalList.vue?vue&type=template&id=4c66ab0b&scoped=true"
import script from "./illlegalList.vue?vue&type=script&lang=js"
export * from "./illlegalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c66ab0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c66ab0b')) {
      api.createRecord('4c66ab0b', component.options)
    } else {
      api.reload('4c66ab0b', component.options)
    }
    module.hot.accept("./illlegalList.vue?vue&type=template&id=4c66ab0b&scoped=true", function () {
      api.rerender('4c66ab0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/credit/report/pdfDataInfo/mainRewardInfo/illlegalList.vue"
export default component.exports